import React from 'react';
import '../styles/components/imageButton.scss';

export default function ImageButton({
	image,
	onClickHandler,
	className,
	disabled,
	text,
}: ImageButtonPops) {
	return (
		<button
			onClick={() => onClickHandler()}
			className={className || ''}
			disabled={disabled}
		>
			{image && <img src={image} alt='' />}
			{text || ''}
		</button>
	);
}
type ImageButtonPops = {
	image?: string;
	onClickHandler: () => void;
	className?: string | undefined;
	disabled: boolean;
	text?: any;
};
